import {Injectable} from '@angular/core';
import {AdminService as Api, Response} from '../../generated/sales-terminal-client';
import {
  AdminService as TranslationApi,
  Translation,
  TranslationPost,
  TranslationPut,
  TranslationsPage
} from '../../generated/translation-client';
import {Observable, tap} from 'rxjs';
import {SnackService} from '../snack/snack.service';
import {PageableSearch} from '../../components/scroll-load-component/scroll-load.component';

export interface TranslationsSearch extends PageableSearch {
  key?: string;
  word?: string;
  startDate?: string;
  endDate?: string;
  isCentreBased?: boolean;
  untranslatedLanguage?: string;
}

@Injectable()
export class AdminService {
  constructor(private _api: Api,
              private _translationApi: TranslationApi,
              private snackService: SnackService) {}

  public deleteRegistrationData(eventId: number): Observable<Response[]> {
    return this._api.adminRegistrationPut(eventId).pipe(
      tap({error: (e) => this.snackService.showBackendError(e)})
    );
  }

  public searchTranslations(data: TranslationsSearch): Observable<TranslationsPage> {
    return this._translationApi.searchTranslations(data.key, data.word, data.startDate, data.endDate, data.page, data.pageSize, data.isCentreBased, data.untranslatedLanguage).pipe(
      tap({error: (e) => this.snackService.showBackendError(e)})
    );
  }

  public getTranslation(key: string, isCentreBased?: boolean): Observable<Translation> {
    return this._translationApi.getTranslation(key, isCentreBased).pipe(
      tap({error: (e) => console.error(e)})
    );
  }

  public createTranslation(translation: TranslationPost): Observable<Translation> {
    return this._translationApi.createTranslation(translation).pipe(
      tap({error: (e) => this.snackService.showBackendError(e)})
    );
  }

  public updateTranslation(key: string, translation: TranslationPut): Observable<Translation> {
    return this._translationApi.updateTranslation(key, translation).pipe(
      tap({error: (e) => this.snackService.showBackendError(e)})
    );
  }

  public deleteTranslation(key: string, isCentreBased: boolean = false): Observable<any> {
    return this._translationApi.deleteTranslation(key, isCentreBased).pipe(
      tap({error: (e) => this.snackService.showBackendError(e)})
    );
  }

  public downloadTranslations(startDate: string, endDate: string): Observable<{ [key: string]: { [key: string]: string; }; }> {
    return this._translationApi.downloadTranslations(startDate, endDate).pipe(
      tap({error: (e) => this.snackService.showBackendError(e)})
    );
  }

  public updateTranslations(translations: { [key: string]: { [key: string]: string; }; }): Observable<any> {
    return this._translationApi.uploadTranslations(translations).pipe(
      tap({error: (e) => this.snackService.showBackendError(e)})
    );
  }
}
